/**
 * 債権者の CSV・一覧表 PDF・宛名ラベル PDF の取得のトースト — 英語。
 * 形は `creditorExportsJa` と同じでなければならない (TranslationOf がキーの欠落・余分をエラーにする)。
 */
import type { TranslationOf } from '../../types';
import type { creditorExportsJa } from '../ja/creditorExports';

export const creditorExportsEn: TranslationOf<typeof creditorExportsJa> = {
  csvFailed: 'Could not export the CSV.',
  csvFailedStatus: 'Could not export the CSV ({status}).',
  csvDone: 'CSV downloaded.',
  pdfFailedStatus: 'Could not export the PDF ({status}).',
  pdfDone: 'PDF downloaded.',
  pdfDownloadFailed: 'Could not download the PDF. Try again later.',
  labelPdfFailedStatus: 'Could not export the address label PDF ({status}).',
  labelPdfDone: 'Address label PDF downloaded.',
  labelPdfDownloadFailed: 'Could not download the address label PDF. Try again later.',
};
